<template>
  <section
    class="component-febbc050"
    resmed-component-name="locator_fullwidth_icon-line_text_2cta"
    v-bind:style="styles"
  >
    <div
      class="component"
      v-bind:class="{
        [`text-color-${acf.layout['text-color']}`]: true,
      }"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-md-10 col-lg-8 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
            <p v-html="acf.content"></p>

            <div class="cta mt-4">
              <a
                v-bind:href="acf.cta[0].href"
                v-bind:target="acf.cta[0].target"
                class="ctaButton cta-pill filled-red icon right-arrow mb-3 mb-md-0"
                >{{ acf.cta[0].text }}</a
              >
              <a
                v-if="acf.cta[1]"
                v-bind:href="acf.cta[1].href"
                v-bind:target="acf.cta[1].target"
                class="ctaButton cta-pill hallow-red icon right-arrow"
                v-bind:class="{
                  'hallow-white': acf.layout['text-color'] === 'white',
                }"
                >{{ acf.cta[1].text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-febbc050", // locator_fullwidth_icon-line_text_2cta
  props: ["acf"],
  data() {
    return {
      styles: {
        "background-color": this.acf.layout["background-color"],
        "background-size": this.acf.layout["background-size"],
        "background-position": this.acf.layout["background-position"],
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        this.$set(
          this.styles,
          "background-image",
          `url(${this.acf.layout["background-image"]})`
        );

        if (["md", "lg"].includes(val)) {
          this.$set(this.styles, "padding-top", this.acf.layout["padding-top"]);
          this.$set(
            this.styles,
            "padding-bottom",
            this.acf.layout["padding-bottom"]
          );
        }

        if (["xl"].includes(val)) {
          this.$set(
            this.styles,
            "padding-top",
            this.acf.layout["padding-top-xl"]
          );
          this.$set(
            this.styles,
            "padding-bottom",
            this.acf.layout["padding-bottom-xl"]
          );
        }

        if (
          ["xs", "sm"].includes(val) &&
          this.acf.layout["background-image-xs"]
        ) {
          this.$set(
            this.styles,
            "background-image",
            `url(${this.acf.layout["background-image-xs"]})`
          );
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-febbc050 {
  padding: 5.5rem 0 4.5rem 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  @media (min-width: 992px) {
    padding: 9rem 0;
  }
}

.component {
  &.text-color-white {
    h2,
    p {
      color: $cc-resmed-white;
    }

    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  svg {
    transform: translateY(-1.75rem);
  }

  h2 {
    position: relative;
    margin: 0 0 1rem 0;

    @extend %eyebrow-center;
  }

  .cta {
    > a {
      margin: 0 0.5rem;
    }
  }
}
</style>